var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    fill: "#E469D1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 7.062a.976.976 0 01-.582-.18L.016 2.673v7.225c0 .596.424 1.102.96 1.102H13.04c.52 0 .96-.488.96-1.102V2.673L7.582 6.882a1.01 1.01 0 01-.582.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.04 0H.96C.44 0 0 .488 0 1.102v.217L6.921 5.87c.048.036.095.036.142 0l6.921-4.551v-.217C13.984.488 13.56 0 13.04 0z"
  }))));
};

export default SvgMail;